import React, { Component } from 'react'
import { Col, Row, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'

/**
 * Basic component providing styling and responsiveness for rendering a 404
 * error. This is broken out so that it can be used in the Generic404 and
 * CalcContainer.
 */
export default class FourOFourBody extends Component {
  /**
   * Render the component
   */
  render () {
    const headerStyle = {
      paddingTop: 40,
      paddingLeft: 20,
      paddingRight: 20,
      fontWeight: 'normal',
      color: '#00B084',
      fontSize: 60,
      textAlign: 'left',
      fontFamily: 'Italianno, cursive',
      zIndex: 10,
      textShadow: '2px 2px 4px rgba(150, 150, 150, 1)'
    }

    const textStyle = {
      paddingLeft: 20,
      paddingRight: 20
    }
    const btnStyle = {
      color: '#00B084',
      fontStyle: 'normal'
    }
    const linkStyle = {
      textAlign: 'center',
      paddingBottom: 40,
      paddingTop: 30
    }
    return (
      <div>
        <Row>
          <Col xs={0} sm={1} />
          <Col xs={12} sm={10} md={8} lg={8}>
            <div style={headerStyle}>404...</div>
            <div style={textStyle}>
              Sorry, we couldn't find the page you're looking for.
            </div>
          </Col>
          <Col xs={0} sm={1} md={3} lg={3} />
        </Row>
        <Row>
          <Col style={linkStyle} xs={12}>
            <Link to='/'>
              <Button bsSize='large' style={btnStyle}>
                Home
              </Button>
            </Link>
          </Col>
        </Row>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/FourOFourBody.js